/**
 * Forme de comparaison d'un nom de catégorie.
 *
 * Ce fichier ne contient QUE cette fonction, et surtout aucun appel réseau :
 * c'est ce qui le rend importable depuis un composant client. `helpers/articleCategories.js`,
 * où elle vivait, lit `process.env.BELIEVEMY_SECRET_TOKEN` pour interroger le
 * back, et le bloc `env:` de next.config.mjs inline cette valeur dans tout
 * bundle navigateur qui touche au module (voir la note sur la recopie de la
 * liste des catégories dans helpers/articleStructuredData.js).
 *
 * Le blog a porté deux catégories pour la même chose, « nocode » et
 * « no-code », chacune avec ses articles. Elles ont été fusionnées sous
 * « no-code », et cette normalisation existe pour que la fusion ne se paie pas
 * en classements perdus : un modèle qui répond « nocode », un fichier d'import
 * écrit à la main, un ancien brouillon, tout retombe sur la bonne catégorie.
 *
 * Minuscules, accents dépliés, tout ce qui n'est ni lettre ni chiffre retiré.
 *
 * Miroir PHP : src/Service/CategoryNameResolver.php du dépôt Symfony
 * (canonicalKey). Toute modification ici doit y être reportée, sinon le front
 * écarte un nom que le back aurait accepté.
 */
export function canonicalCategoryKey(name) {
    if (typeof name !== "string") return "";

    return name
        .trim()
        .toLowerCase()
        .normalize("NFD")
        .replace(/[\u0300-\u036f]/g, "")
        .replace(/[^a-z0-9]+/g, "");
}
